const removeMkdocsHeader = () => {
  return (dom) => {
    dom.querySelector(".md-header")?.remove();
    return dom;
  };
};

export { removeMkdocsHeader };
//# sourceMappingURL=removeMkdocsHeader.esm.js.map
